export class ShirtLogo
{
  constructor(form, orderSummary) {
    this.schoolLogo = form.querySelector('[name="school_logo"]');
    this.customSchoolLogo = form.querySelector('[name="custom[school_logo]"]');
    this.orderSummary = orderSummary;

    this.bindEvents();
  }

  bindEvents() {
    if (this.schoolLogo) {
      this.schoolLogo.addEventListener('change', () => this.refresh());
    }
  }

  refresh() {
    this.customSchoolLogo.value = this.schoolLogo.value !== null;
    this.orderSummary.refresh();
  }
}
